import imagesLoaded from 'imagesloaded';
import Swiper, { Autoplay, FreeMode } from 'swiper';
import { gsap } from 'gsap';
import Component from '../Component';

class HeroGallery extends Component {
  constructor(options) {
    super(options);
    this.thumbnail = this.root.querySelectorAll('img');
  }

  heroLoaded() {
    this.root.classList.add('hero_loaded');
  }

  attachEventListeners() {
    imagesLoaded(this.root, () => {
      new Swiper(this.root, {
        modules: [Autoplay, FreeMode],
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: {
          enabled: true
        },
        draggable: true,
        loop: true,
        grabCursor: true,
        on: {
          slideChangeTransitionStart: (swiper) => {
            const { $wrapperEl } = swiper;
            const { params } = swiper;
            $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
              .each((slide) => {
                const idx = slide.getAttribute('data-swiper-slide-index');
                this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
              });
          }
        }
      });

      const tl = gsap.timeline({ onComplete: this.heroLoaded() });
      this.thumbnail.forEach((thumb) => {
        tl.from(thumb, 0.5, {
          autoAlpha: 0
        }, Math.random() * 2);
      });
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default HeroGallery;
